export default "__VITE_ASSET__BRyJ$CLr__"